import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["onChange", "value"];

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-12 17:19:53
 * @LastEditTime: 2022-01-13 18:52:27
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React from 'react';
import { Select } from 'zarm'; // value sting | []

export default (props => {
  const {
    onChange,
    value
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  let cValue = value;

  if (typeof value === 'string') {
    cValue = value.split(',');
  }

  return /*#__PURE__*/React.createElement(Select, _extends({
    onOk: val => {
      let nextVal = [];

      if (Array.isArray(val) && val.length > 0) {
        nextVal = val.map(i => {
          if (typeof i === 'object') {
            const key = rest.valueMember || 'code';
            return i[key];
          }

          return i;
        });
      }

      if (nextVal.length === 1) return onChange(nextVal[0]);
      onChange(nextVal.join());
    }
  }, rest, {
    value: cValue
  }));
});